import $ from 'jquery';
import _ from 'lodash';
import Backbone from 'backbone';
import SiteSectionPropertyModel from 'models/properties/siteSectionPropertyModel';
import {ajaxRequest} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';

const SiteTreeModel = Backbone.Model.extend({
    idAttribute: 'siteUuid',
    urlRoot: '/api/site-tree',
    defaults: {
        // 'name': null,
        // 'status': 'DRAFT',
        // 'config': null,
        // 'pathUrl': '',
        // 'version': 1,
        // 'created': 1,
        // 'children': [],
        // 'savedDate': null,
        // 'parentSite': {},
        // 'goLiveDate': null,
        // 'takeDownDate': null,
        // 'propertyTags': [],
        // 'presentations': [],
        // 'parentSection': {},
        // 'universalSections': [],
        // 'propertyAttributes': [],
        // 'parentChannelProperty': {},
        // 'publishAuthorizationDate': null,
        // 'unpublishAuthorizationDate': null
    },
    blacklist: ['siteUuid'],
    parse(data) {
        let model = data && (_.isArray(data.data) && data.data.length > 0) ? data.data[0] : data;

        if (model && model.response) {
            delete model.response;
        }

        model = this.setSectionOrder(model);
        model = this.setPresentationOrder(model);

        return model;
    },
    getModelId() {
        return this.attributes.uuid;
    },
    getName() {
        return this.attributes.name;
    },
    getStatus() {
        return this.attributes.status;
    },
    getPathUrl() {
        return this.attributes.pathUrl;
    },
    getConfig() {
        return this.attributes.config;
    },
    getVersion() {
        return this.attributes.version;
    },
    getCreated() {
        return this.attributes.created;
    },
    getChildren() {
        return this.attributes.children;
    },
    getSavedDate() {
        return this.attributes.savedDate;
    },
    getParentSite() {
        return this.attributes.parentSite;
    },
    getGoLiveDate() {
        return this.attributes.goLiveDate;
    },
    getTakeDownDate() {
        return this.attributes.takeDownDate;
    },
    getPropertyTags() {
        return this.attributes.propertyTags;
    },
    getPresentations() {
        return this.attributes.presentations;
    },
    getParentSection() {
        return this.attributes.parentSection;
    },
    getUniversalSections() {
        return this.attributes.universalSections;
    },
    getPropertyAttributes() {
        return this.attributes.propertyAttributes;
    },
    getParentChannelProperty() {
        return this.attributes.parentChannelProperty;
    },
    getParentSiteId() {
        return this.attributes.parentSite && this.attributes.parentSite.uuid
            ? this.attributes.parentSite.uuid
            : undefined;
    },

    getPublishAuthorizationDate() {
        return this.attributes.publishAuthorizationDate;
    },
    setPublishAuthorizationDate(date) {
        this.set({
            publishAuthorizationDate: date,
        });
    },

    getUnpublishAuthorizationDate() {
        return this.attributes.unpublishAuthorizationDate;
    },
    setUnpublishAuthorizationDate(date) {
        this.set({
            unpublishAuthorizationDate: date,
        });
    },

    /***************************************/
    // WILL SET THE LOCK AND CORRECT ORDER OF SECTIONS
    setSectionOrder(model) {
        const sections = [];
        const siteTreeModel = this;
        if (model && model.children && _.isArray(model.children)) {
            $(model.children).each(function() {
                if (this.order === null) {
                    if (this.name.toLowerCase() === 'news') {
                        this.order = 1;
                        this.locked = true;
                    } else if (this.name.toLowerCase() === 'weather') {
                        this.order = 2;
                        this.locked = true;
                    } else {
                        this.order = siteTreeModel.getMaxOrder(model.children);
                    }

                    //SAVE ALL SECTION THAT DO NOT HAVE A ORDER NUMBER
                    sections.push(this);
                }
            });
            // NOW SORT THE
            model.children = model.children.sort(function(a, b) {
                return a.order > b.order;
            });
            // NOW PROCESS NODES IN BACKGROUND
            this.processSections(sections);
        }

        return model;
    },
    getMaxOrder(sections) {
        const max = _.maxBy(sections, function(section) {
            return section.order;
        });

        return max && max.order > 2 ? max.order + 1 : 3;
    },
    setPresentationOrder: function setPresentationOrder(model) {
        const that = this;

        if (model && model.presentations && _.isArray(model.presentations)) {
            // NOW SORT THE
            model.presentations = model.presentations.sort(function(a, b) {
                return that.getPresentationOrderNumber(a) > that.getPresentationOrderNumber(b);
            });
        }

        return model;
    },
    getPresentationOrderNumber(presentation) {
        let number = 0;
        const str = presentation.name.toLowerCase();

        if (str.includes('home')) {
            number = 1;
        } else if (str.includes('story')) {
            number = 2;
        } else if (str.includes('gallery')) {
            number = 3;
        } else if (str.includes('video')) {
            number = 4;
        } else {
            number = 100;
        }

        return number;
    },
    processSections(sections) {
        const opts = {
            success() {
                this.processSections(sections);
            },
        };
        const optsII = {
            success(model, response, data, options) {
                model.save(
                    {
                        locked: options.locked,
                        order: options.order,
                    },
                    opts,
                );
            },
        };
        if (_.isArray(sections) && sections.length > 0) {
            const s = sections.shift();

            if (s) {
                const section = new SiteSectionPropertyModel(s);

                optsII.order = section.getOrder();
                optsII.locked = section.getLocked();
                // NEED TO GET THE WHOLE MODEL FIRST, THEN CHANGE VALUES AND SAVE IT
            }
        }
    },
    _setState(state, options = {}) {
        const parentSiteRequestOptions = Object.assign(
            {
                url: `/platform/property/status/${this.get('parentSite').uuid}/${state}`,
                method: 'POST',
            },
            options,
        );
        const siteRequestOptions = Object.assign(
            {
                url: `/platform/property/status/${this.get('uuid')}/${state}`,
                method: 'POST',
            },
            options,
        );

        // Send request without request BODY using plain jQuery method for 'UNPUBLISHED' state only
        if (state === 'UNPUBLISHED') {
            return ajaxRequest(parentSiteRequestOptions).then(() => ajaxRequest(siteRequestOptions));
        } else {
            return this.save({}, parentSiteRequestOptions).then(() => this.save({}, siteRequestOptions));
        }
    },
    publish(options) {
        return this._setState('PUBLISHED', options);
    },
    unpublish(options) {
        return this._setState('UNPUBLISHED', options);
    },
});
//
export default SiteTreeModel;
